<template>
  <!-- record -->
  <div class="receipt" style="font-family: '微软雅黑';">
    <div class="page" v-for="(item, index) in record.patientInfusionList" :id='scriptInfo(index)' :key="index + 'info'">
      <!-- 处方信息 -->
      <div style="font-size: 8pt; line-height: 12pt;font-family: '微软雅黑';">
        <p style="float: left;">NO.{{record.inquiryInfo.recordId}}</p>
        <div style="float: right;">
          <p style="display: inline-block;float: right;">
            <span tdata="pageNO" format="#">##</span>/<span tdata="pageCount" format="#">##</span>
          </p>
          <p style="width: 25pt;float: right; text-align:center;height: 14pt;line-height: 14pt;border: 1pt solid rgba(51,51,51,1);border-radius: 3pt;display: inline-block;margin-right: 8pt;">普通</p>
        </div>
      </div>
      <div style="clear: both;"></div>
      <h3 style="text-align: center; font-size: 16pt;margin-top: 0pt;font-family: '微软雅黑';font-weight: normal;">{{$store.state.global.countInfo.hospitalName}}</h3>
      <h4 style="text-align: center; font-size: 12pt;margin-top: -12pt;font-family: '微软雅黑';font-weight: normal;">输液卡</h4>
      <div class="user-info" style="font-size: 9pt;margin-top: -8pt;font-family: '微软雅黑';">
        <div style="border-bottom: 1pt solid #999; line-height: 24pt;height: 24pt;">
          <div style="display: inline-block;width: 33.333%; float: left;">
            姓名：{{record.patient.patientName}}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
            性别：{{record.patient.gender == -1 ? '未知' : (record.patient.gender == 0 ? '女' : '男') }}
          </div>
          <div style="display: inline-block;width: 33.333%; float: left;">
            年龄：
            <span v-if="record.inquiryInfo.clinicalAge">{{record.inquiryInfo.clinicalAge}}</span>
            <span v-else>
              <span v-if="record.patient.year > 0">{{record.patient.year}}岁</span>
              <span v-if="record.patient.month > 0 && record.patient.year >= 0 && record.patient.year < 5">{{record.patient.month}}月</span>
              <span v-if="record.patient.year === 0 && record.patient.day > 0">{{record.patient.day}}天</span>
            </span>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div style="border-bottom: 1pt solid #999;line-height: 24pt;height: 24pt;">
          <div style="display: inline-block;width: 33.333%; float: left;">
            手机号：{{record.patient.phoneNo}}
          </div>
          <div style="display: inline-block;width: 33.333%;float: left;">
            科室：{{laboratoryName}}
          </div>
          <div style="display: inline-block;width: 33.333%;float: left;">
            就诊日期：{{record.inquiryInfo.clinicalTime}}
          </div>
        </div>
        <div style="border-bottom: 1pt solid #999;line-height: 24pt;height: 24pt;">
          <div>
            临床诊断：{{record.inquiryInfo.diagnosisResultString}}
          </div>
        </div>
      </div>
      <!-- 字母 -->
      <!-- <div style="line-height: 11pt;">
        <h1 style="font-size: 17pt;display: inline-block;font-family:DFPSongW7;float:left;">R</h1>
        <h2 style="font-size: 12pt;display: inline-block;font-family:DFPSongW7;float:left;margin-left: 4pt">p</h2>
      </div>
      <div style="clear: both;"></div> -->
    </div>
    <!-- 处方 -->
    <div class="page" v-for="(item, index) in scriptList" :id='idAdd(index)' :key="index+'cardinfo'">
      <!-- 输液处方 -->
      <TABLE border=0 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse;font-size: 12pt;border: none;font-family: '微软雅黑';">    
        <TBODY>      
          <TR>
            <TD height="">
              <div class="group" style="margin-bottom: 12pt;" v-for="(it, idx) in item.patientInfusionGroupList" :key="idx+ 'label'">
                <div style="font-size:9pt;"> 组{{idx + 1}}：&nbsp;&nbsp;{{it.usage}} &nbsp;&nbsp;&nbsp;{{it.useRate}} &nbsp;&nbsp;&nbsp;{{it.dayCount}} 天&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span v-if="it.drippingSpeed !== '' && it.speedUnit !== ''">滴速：{{ it.drippingSpeed }} {{it.speedUnit}}</span>
                </div>
                <TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse;font-size: 9pt;border-color:#fff;margin-top:1.6pt;">
                  <TBODY>
                    <TR style="min-height: 16pt;">
                      <TD style="width: 40%;border-color:#999;">药品名称</TD>
                      <TD style="border-color:#999;">单次剂量</TD>
                      <TD style="border-color:#999;">皮试</TD>
                      <TD style="width: 52pt;border-color:#999;">日期</TD>
                      <TD style="border-color:#999;">配药人</TD>
                      <TD style="border-color:#999;">核对人</TD>
                      <TD style="border-color:#999;">执行人</TD>
                    </TR>
                    <TR v-for="(i, id) in it.patientDrugList" :key="id + 'prescription'" :style="{height: i.drugName ? 'auto' : '20pt'}" style="min-height: 20pt;border-color:#999;">
                      <TD style="width: 40%;border-color: #999;">
                        <div>{{i.drugName}} {{i.specification}}</div>
                      </TD>
                      <TD style="border-color:#999;">{{i.dosage}} {{i.dosageUnit}}</TD>
                      <TD style="text-align: center;border-color:#999;">
                        {{i.skinTest}}
                      </TD>
                      <TD style="width: 50pt;border-color:#999;">
                        <span v-if="id === 0">{{it.startTime}}</span>
                      </TD>
                      <TD style="border-color:#999;"></TD>
                      <TD style="border-color:#999;"></TD>
                      <TD style="border-color:#999;"></TD>
                    </TR>
                  </TBODY>
                </TABLE>
              </div>
            </TD>
          </TR>
        </TBODY>
      </TABLE>
    </div>
    <!-- 诊所信息 -->
    <div style="margin-top: 0pt;font-size: 9pt; font-family: '微软雅黑';" id="footer-info-card">
      <div style="font-size: 9pt;border-bottom: 1pt solid #999; line-height: 24pt;height:24pt; font-family: '微软雅黑';">
        <div style="float: left; width: 49.99%;">
          打印时间：{{ printTime }}
        </div>
        <div style="float: left; width: 49.99%;">
          医生：<span v-if="printConfig.printDoctorName == 1">{{ record.realName }}</span>
        </div>
      </div>
      <div style="clear: both;"></div>
      <div style="font-size: 9pt;margin-top:4pt; font-family: '微软雅黑';">注：{{ printConfig.remark }}</div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { getLodop } from '@/plugins/LodopFuncs.js';
import { cloneDeep } from 'lodash';

export default {
 /** 
  *  type 的几种类型
  *  medicine -> 成药
  *  pieces -> 饮片
  *  infusion -> 输液
  *  apply -> 服帖
  *  infusionCard -> 输液卡
  *  other -> 其他
 */
  props: {
    record: {
      type: Object,
      default: {},
    },
    isReview: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      printConfig: {
        printDoctorName: 0, // 是否打印名字
        printTotalPrice: 0, // 是否显示价格
        remark: 0, // 打印备注
      },
      printTime: '',
      cur_type: 'infusion-card',
      scriptList: [],
      count: 1,
    }
  },
  methods: {
    print() {
      this.printTime = moment().format('YYYY-MM-DD HH:mm:ss');
      console.log(this.record.inquiryInfo.doctorName);
      const { infusionValue } = this.$store.state.global.printConfig;
      this.$nextTick(() => {
        const LODOP = getLodop();
        LODOP.SET_LICENSES("","94E6E7FFD51B8CCBE5F216686981579D","C94CEE276DB2187AE6B65D56B3FC2848","");
        LODOP.PRINT_INIT('输液卡打印');
        LODOP.SET_PRINT_PAGESIZE(1, '148mm', '210mm', 'A4');
        this.record.patientInfusionList.forEach((item, index) => {
          LODOP.ADD_PRINT_HTM(0, '5%', '90%', 180, document.getElementById(`${this.cur_type}-info` + index).innerHTML);
          LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
          LODOP.SET_PRINT_STYLEA(0, "Vorient",3);	
          LODOP.ADD_PRINT_HTM(220, '5%','90%', 450, document.getElementById(this.cur_type + index).innerHTML);
          LODOP.ADD_PRINT_HTM(650, '5%', '90%', 100, document.getElementById('footer-info-card').innerHTML);
          LODOP.SET_PRINT_STYLEA(0,"ItemType",1);
          LODOP.SET_PRINT_STYLEA(0,"LinkedItem",1);	
          LODOP.NewPageA();
        });
        LODOP.SET_PRINT_MODE("RESELECT_PAGESIZE", true); // 可以自行修改打印尺寸
        LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); // 打印后自动关闭预览窗口
        LODOP.SET_PRINTER_INDEX(infusionValue);
        LODOP.PREVIEW();
        // if (this.isReview) {
        //   LODOP.PREVIEW();
        // }
        // LODOP.PRINT();
      });
    },
    
    // 计算金额
    drugAmt(price, num) {
      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return '0.00';
      return BN(price).multipliedBy(num).toFixed(3);
    },
    // 获取打印配置
    getPrintConfig() {
      this.$api.clinicManagement.getPrintConfit({configType: 6}).then((res) => {
        this.printConfig = res;
      })
    },
    scriptInfo(index) {
      return `${this.cur_type}-info` + index;
    },
    idAdd(index) {
      return this.cur_type + index;
    }
  },
  mounted() {
    this.getPrintConfig();
  },
  computed: {
    laboratoryName() {
       return this.$store.state.global.countInfo.laboratoryName;
    }
  },
  watch: {
    record(val) {
      if(Array.isArray(val.patientInfusionList) && val.patientInfusionList.length > 0) {
        // 深拷贝不影响父级组件
        const patientInfusionList = cloneDeep(val.patientInfusionList);
        this.scriptList = patientInfusionList.map((item) => {
          item.patientInfusionGroupList = item.patientInfusionGroupList.map((it) => {
            console.log(it.startTime);
            it.startTime = it.startTime.slice(0, 10);
            this.count = 1;
            it.patientDrugList = it.patientDrugList.map((i) => {
              i.skinTest = i.skinTest ? i.skinTest : '--';
              switch(it.useRate) {
                case '1日2次(bid)':
                this.count = 2;
                break;
                case '1日3次(tid)':
                this.count = 3;
                break;
                case '1日4次(qid)':
                this.count = 4;
                break;
                default:
                break;
              }
              return i;
            });
            if (this.count * it.dayCount > it.patientDrugList.length) {
              const len = this.count * it.dayCount - it.patientDrugList.length;
              for(let d = 0; d < len; d++) {
                it.patientDrugList.push({});
              }
            }
            return it;
          });
          return item;
        });
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.header-info {
  border-bottom: 2px solid #000000;
}

.receipt {
  width: 300px;
  justify-content: space-between;
}
span {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #AAAAAA;
}

.receipt {
  position: fixed;
  border: 1px solid #000000;
  z-index: 100;
  width: 1000px;
  background: white;
  left: -5000px;
  top: 100px;
}
</style>

